import { combineReducers, Reducer } from 'redux';
import { reducer as wishlistReducer } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlist/reducer';
import { reducer as wishlistActionsReducer } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlistActions/reducer';
import { reducer as wishlistsReducer } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlists/reducer';
import { reducer as wishlistSearchReducer } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlistsSearch/reducer';
import { WishlistsAction, WishlistsState } from './types';

const reducer: Reducer<WishlistsState, WishlistsAction> = combineReducers({
  wishlists: wishlistsReducer,
  wishlist: wishlistReducer,
  wishlistActions: wishlistActionsReducer,
  wishlistsSearch: wishlistSearchReducer,
});

export {
  reducer,
};
